/* Vionine — urun aciklamasinda "read more". Ilk paragraf gorunur, sonrakiler katlanir.
   Akordeonlar ve hero kutusu kapsam disi (TR ile ayni). Metne dokunmaz. */
(function () {
  var LABEL_MORE = "… read more", LABEL_LESS = "read less", ACCENT = "#5a4b7c", ACCENT_HOVER = "#3a2f52";
  var SELECTORS = ["#pgd", ".t4s-product-tabs-wrapper .t4s-rte", ".t4s-rte", "[data-product-description]"];
  function pickHosts() {
    var out = [];
    for (var i = 0; i < SELECTORS.length; i++) {
      var nodes = document.querySelectorAll(SELECTORS[i]);
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (out.indexOf(n) !== -1 || n.hasAttribute("data-vio-rm")) continue;
        var nested = false;
        for (var k = 0; k < out.length; k++) { if (out[k].contains(n)) { nested = true; break; } }
        if (!nested) out.push(n);
      }
      if (out.length) break;
    }
    return out;
  }
  function findTextBlock(host) {
    var kids = host.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.tagName === "SCRIPT" || el.tagName === "STYLE") continue;
      if (el.className && String(el.className).indexOf("vio-rm") !== -1) continue;
      if (el.querySelector("details, summary")) continue;
      if (el.querySelectorAll(":scope > p").length >= 2) return el;
    }
    if (host.querySelectorAll(":scope > p").length >= 2) return host;
    return null;
  }
  function build(host) {
    if (host.hasAttribute("data-vio-rm")) return;
    var block = findTextBlock(host);
    if (!block) return;
    var kids = [];
    for (var c = 0; c < block.children.length; c++) {
      var ch = block.children[c];
      if (ch.tagName === "SCRIPT" || ch.tagName === "STYLE") continue;
      if (ch.className && String(ch.className).indexOf("vio-rm") !== -1) continue;
      kids.push(ch);
    }
    var firstP = -1;
    for (var q = 0; q < kids.length; q++) { if (kids[q].tagName === "P") { firstP = q; break; } }
    if (firstP === -1 || firstP >= kids.length - 1) return;
    host.setAttribute("data-vio-rm", "1");
    var fold = document.createElement("div");
    fold.className = "vio-rm-fold";
    fold.style.cssText = "overflow:hidden;height:0;transition:height .28s ease;";
    kids[firstP].parentNode.insertBefore(fold, kids[firstP].nextSibling);
    for (var r = firstP + 1; r < kids.length; r++) fold.appendChild(kids[r]);
    var btn = document.createElement("button");
    btn.type = "button"; btn.className = "vio-rm-btn"; btn.textContent = LABEL_MORE; btn.setAttribute("aria-expanded", "false");
    btn.style.cssText = "display:block;margin:2px 0 0;padding:0;background:none;border:0;border-radius:0;color:" + ACCENT + ";font-family:inherit;font-size:13.5px;font-weight:500;letter-spacing:0;text-transform:none;line-height:1.5;text-align:left;cursor:pointer;";
    btn.addEventListener("mouseenter", function () { btn.style.color = ACCENT_HOVER; });
    btn.addEventListener("mouseleave", function () { btn.style.color = ACCENT; });
    fold.parentNode.insertBefore(btn, fold.nextSibling);
    var open = false;
    btn.addEventListener("click", function () {
      open = !open;
      if (open) { fold.style.height = fold.scrollHeight + "px"; window.setTimeout(function () { if (open) fold.style.height = "auto"; }, 300); }
      else { fold.style.height = fold.scrollHeight + "px"; window.requestAnimationFrame(function () { fold.style.height = "0px"; }); }
      btn.textContent = open ? LABEL_LESS : LABEL_MORE;
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }
  function run() { var hosts = pickHosts(); for (var i = 0; i < hosts.length; i++) build(hosts[i]); }
  function start() { run(); var tries = 0; var iv = window.setInterval(function () { tries++; run(); if (tries > 14) window.clearInterval(iv); }, 400); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
